"use client";

import { PremiumPlansRow } from "@/components/billing/premium-plans-row";
import { useLeadRequest } from "@/components/landing/lead-request-context";
import { formCaseKeyForPlanSlug } from "@/lib/bitrix24/form-cases";
import type { PlanPackDefinition } from "@/lib/billing/plan-display";

type Props = {
  plans: PlanPackDefinition[];
  title?: string;
  subtitle?: string;
  actionLabel?: string;
};

/** Корпоративные тарифы на лендинге: «Оставить заявку» → модалка CRM. */
export function LandingPremiumPlansWithLead({
  plans,
  title,
  subtitle,
  actionLabel,
}: Props) {
  const { openLeadRequest } = useLeadRequest();

  return (
    <PremiumPlansRow
      plans={plans}
      title={title}
      subtitle={subtitle}
      actionLabel={actionLabel}
      onInquiry={(slug) => {
        const key =
          formCaseKeyForPlanSlug(slug) ?? "enterprise-request";
        const pack = plans.find((p) => p.slug === slug);
        openLeadRequest({
          formCaseKey: key,
          title: pack
            ? `Заявка: ${pack.cardTitle}`
            : "Оставить заявку",
          subtitle:
            "Оставьте контакты — обсудим условия и вернёмся с предложением.",
        });
      }}
    />
  );
}
